import { render } from "./SectionsItem.vue?vue&type=template&id=10c97f7c&lang=html"
import script from "./SectionsItem.vue?vue&type=script&lang=js"
export * from "./SectionsItem.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__